import React from 'react';
import { NavLink } from 'react-router-dom';

const LOGO_SRC = '/images/logo.svg';

const navItems = [
  {
    label: 'Dashboard Management',
    icon: 'bi-speedometer2',
    children: [
      { to: '/', label: 'Dashboard' },
      { to: '/templates', label: 'Templates' },
      { to: '/tools', label: 'Tools' },
    ],
  },
  {
    label: 'Content Management',
    icon: 'bi-journal-text',
    children: [
      { to: '/content', label: 'Content' }
    ],
  },
];

export default function AppSidebar() {
  return (
    <aside className="app-sidebar">
      <nav className="nav flex-column">
        {navItems.map((item) =>
          item.children ? (
            <div key={item.label}>
              <div className="nav-group-label">
                <i className={item.icon} />
                {item.label}
              </div>
              {item.children.map((child) => (
                <NavLink
                  key={child.to}
                  to={child.to}
                  className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                >
                  <i className="bi bi-dot" />
                  {child.label}
                </NavLink>
              ))}
            </div>
          ) : (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
            >
              <i className={item.icon} />
              {item.label}
            </NavLink>
          )
        )}
      </nav>
    </aside>
  );
}
